'use strict';
module.exports = require('./ColumnGroup.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/columngroup/index.js
// module id = 380
// module chunks = 1